import { colors } from '../../style';
import AntdText, { TextProps as AntdTextProps } from "antd/es/typography/Text";
import styled from "styled-components";

export interface TextProps extends AntdTextProps {
  color?: "primary" | "secondary" | "tertiary" | "black" | "white";
  colorCode?: string;
  level?: 1 | 2 | 3;
}

interface InternalTextProps {
  color?: string;
  level: 1 | 2 | 3;
}

const StyledAntdText = styled(AntdText)<InternalTextProps>`
  ${({ color }) => `color: ${color};`}
  text-transform: none;
  font-family: "Bio Sans Regular";

  /* @media screen and (min-width: 601px) {
    ${({ level }) => {
      switch (level) {
        case 1:
          return `font-size: 35px !important; line-height: 39px !important;`;
        case 2:
          return `font-size: 20px !important; line-height: 24px !important;`;
        case 3:
          return `font-size: 16px !important; line-height: 20px !important;`;
      }
    }}
  } */

  /* @media screen and (max-width: 600px) { */
    ${({ level }) => {
      switch (level) {
        case 1:
          return `font-size: 15px !important; line-height: 17px !important;`;
        case 2:
          return `font-size: 13px !important; line-height: 15px !important;`;
        case 3:
          return `font-size: 10px !important; line-height: 12px !important;`;
      }
    }}
  /* } */
`;

/**
 * A Text component that supports our use of custom styles
 */
export default function Text({ children, color, colorCode, level = 2, ...props }: TextProps) {
  const displayColorCode = colorCode ?? colors[color || "black"];
  return (
    <StyledAntdText
      level={level}
      color={displayColorCode}
      {...props}
    >
      {children}
    </StyledAntdText>
  );
}